/**
 * Confirmação de movimentação manual — bloqueado movível com aviso; reservado intocável.
 */

/** @returns {string|null} mensagem de erro ou null se permitido */
export function manualMoveReservedError(sourceStock, targetStock)
{
	if (sourceStock === 'R' || targetStock === 'R')
	{
		return 'Saldo reservado não pode ser movimentado. Libere ou baixe a saída antes de transferir o estoque.';
	}
	return null;
}

/**
 * Texto de aviso para movimentação de saldo bloqueado (uma linha ou várias).
 * @param {{ sku?: string, lot_number?: string|null, quantity: number }[]} items
 */
export function formatBlockedMoveWarning(items)
{
	const lines = (items || []).filter((i) => Number(i.quantity) > 0);
	if (!lines.length)
		return '';
	const detail = lines.slice(0, 8).map((i) =>
	{
		const sku = i.sku || '?';
		const lot = i.lot_number != null && i.lot_number !== '' ? ` lote ${i.lot_number}` : '';
		return `${sku}${lot}: ${i.quantity} un. bloqueada(s)`;
	}).join('; ');
	const more = lines.length > 8 ? ` … (+${lines.length - 8} SKU(s))` : '';
	const total = lines.reduce((s, i) => s + Number(i.quantity), 0);
	return `Serão movimentadas ${total} unidade(s) bloqueada(s). Detalhe: ${detail}${more}. O saldo reservado não será alterado. Confirma?`;
}

/**
 * Monta mensagem de confirmação para mover posição inteira (409 da API).
 * @param {object} payload resposta move_location_reserve_conflict
 */
export function formatMoveLocationConflictMessage(payload)
{
	const qFree = payload.quantity_free_total ?? 0;
	const qBlocked = payload.quantity_blocked_total ?? 0;
	const outs = (payload.output_ids || []).filter(Boolean);
	const outTxt = outs.length
		? ` Saídas com reserva nesta posição (referência): ${outs.join(', ')}.`
		: '';
	const lines = payload.lines || [];
	const detail = lines.slice(0, 8).map((l) =>
	{
		const sku = l.sku || '?';
		const lot = l.lot_number != null && l.lot_number !== '' ? ` lote ${l.lot_number}` : '';
		return `${sku}${lot}: reservado ${l.quantity_reserved ?? 0}, bloqueado ${l.quantity_unsettled ?? 0}, livre ${l.quantity_available ?? 0}`;
	}).join('; ');
	const more = lines.length > 8 ? ` … (+${lines.length - 8} linha(s))` : '';
	const hasReserved = lines.some((l) => (l.quantity_reserved ?? 0) > 0);
	let msg = (payload.message || 'Confirmação necessária para movimentar esta posição.') + outTxt;
	if (detail)
		msg += ` Detalhe: ${detail}${more}.`;
	if (hasReserved)
		msg += ' O saldo reservado permanece na origem.';
	if (qFree > 0)
		msg += ` Saldo livre: ${qFree} unidade(s).`;
	if (qBlocked > 0)
		msg += ` Saldo bloqueado: ${qBlocked} unidade(s) — serão movidas após confirmação.`;
	if (qFree <= 0 && qBlocked <= 0)
		msg += ' Não há saldo livre nem bloqueado para movimentar.';
	else
		msg += ' Confirma a movimentação?';
	return { msg, qFree, qBlocked, hasReserved };
}

/** Flags para reenvio após confirmação do operador. */
export function moveLocationConfirmFlags(payload)
{
	const qFree = payload.quantity_free_total ?? 0;
	const qBlocked = payload.quantity_blocked_total ?? 0;
	const hasReserved = (payload.lines || []).some((l) => (l.quantity_reserved ?? 0) > 0);
	return {
		move_free_only: hasReserved || Boolean(payload.requires_move_free_only),
		include_blocked: qBlocked > 0 || Boolean(payload.requires_include_blocked),
		canProceed: qFree > 0 || qBlocked > 0,
	};
}
